<template>
  <div class="member_wrap">
    <div class="member">
      <div class="member_top">
        <div class="member_top_textBox">
          <div class="member_top_textBox_title">멘토소개</div>
          <!-- 멘토페이지 이동 -->
          <div class="member_top_textBox_link" @click="movePage('/amidan?tab=mentor')">전체보기</div>
        </div>
        <div class="member_top_swiper_btn">
          <div class="member_top_swiper_btn_prev" slot="button-prev"></div>
          <div class="member_top_swiper_btn_next" slot="button-next"></div>
        </div>
      </div>

      <swiper class="member_swiper" ref="swiper" :options="swiperOption">
        <swiper-slide class="member_swiper_slide" v-for='member in memberData' :key="`member${member.m_idx}`">
          <!--   멘토 사진, 이름, 직업, 소개 글 데이터    -->
          <div class="member_swiper_slide_pic" :style="`background-image:url(${returnImage(member)}`"></div>
          <div class="member_swiper_slide_text_box">
            <div class="member_swiper_slide_name">{{ member.m_name }}</div>
            <div class="member_swiper_slide_job">{{ member.m_job }}</div>
            <div class="member_swiper_slide_text" v-html="decodeHtml(member.m_memo)"></div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "MemberListHomeLayout",
  mixins: [imageOption],
  components: {
    Swiper,
    SwiperSlide
  },
  inject: [],
  provide() {
    return {}
  },
  props: {
    memberData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 9,
        direction: 'horizontal',
        navigation: {
          nextEl: '.member_top_swiper_btn_next',
          prevEl: '.member_top_swiper_btn_prev'
        },
      },
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(member) {
      if (!util.isEmpty(member.profile)) {
        return `${member.profile[0].org_url}?${this.setImageOptions(186, 186, 'jpg')}`; //디자인보고 대충 resize 크기 잡아주세요.
      }
    },
    movePage(path) {
      if (this.$route.path === path) {
        return;
      }
      this.$router.push(path);
    },
    decodeHtml(html = '') {
      return util.htmlDecode(html);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>